import { useCallback, useState } from 'react';
import type { TableProps } from 'antd/es/table';

export type ResultsSortOrder = 'ascend' | 'descend' | null;

/**
 * Server-side sort state for a Results table's Date column — the only
 * sortable column on either tab, so there's nothing to disambiguate beyond
 * ascending/descending (see AdminUsers.tsx for the multi-column version of
 * this pattern). Sort isn't URL-persisted, matching AdminUsers.tsx.
 */
export function useSortOrderState(setPage: (page: number) => void) {
  const [sortOrder, setSortOrder] = useState<ResultsSortOrder>(null);

  const handleTableChange: NonNullable<TableProps<object>['onChange']> = useCallback(
    (_pagination, _filters, sorter) => {
      const s = Array.isArray(sorter) ? sorter[0] : sorter;
      setSortOrder(s?.order ?? null);
      setPage(1);
    },
    [setPage],
  );

  return { sortOrder, handleTableChange };
}
